/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Candidate_Profile_Nav_Matching_WeekInputs */

const en_candidate_profile_nav_matching_week = /** @type {(inputs: Candidate_Profile_Nav_Matching_WeekInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Matching Week`)
};

const de_candidate_profile_nav_matching_week = /** @type {(inputs: Candidate_Profile_Nav_Matching_WeekInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Matching Week`)
};

/**
* | output |
* | --- |
* | "Matching Week" |
*
* @param {Candidate_Profile_Nav_Matching_WeekInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const candidate_profile_nav_matching_week = /** @type {((inputs?: Candidate_Profile_Nav_Matching_WeekInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Candidate_Profile_Nav_Matching_WeekInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_candidate_profile_nav_matching_week(inputs)
	return en_candidate_profile_nav_matching_week(inputs)
});